import {
  Field,
  Input,
  MessageBar,
  MessageBarBody,
  Spinner,
} from '@fluentui/react-components';

import { DataHubClientProvider } from '../../context/DataHubClientContext.js';
import { useDataset } from '../../hooks/useDataset/useDataset.js';

export interface PrivateWorkspaceDatasetDetailsProps {
  datasetId: string;
}

function PrivateWorkspaceDatasetFields({
  datasetId,
}: PrivateWorkspaceDatasetDetailsProps) {
  const { dataset, isLoading, error } = useDataset(datasetId);

  return (
    <>
      <Field
        label="Associated restricted dataset name"
        hint="This Data Lake dataset controls access to this workspace."
      >
        <Input
          aria-label="Associated restricted dataset name"
          value={dataset?.name ?? ''}
          readOnly
          contentAfter={
            isLoading ? (
              <Spinner
                size="tiny"
                aria-label="Loading associated dataset name"
              />
            ) : undefined
          }
        />
      </Field>
      <Field label="Associated restricted dataset ID">
        <Input
          aria-label="Associated restricted dataset ID"
          value={datasetId}
          readOnly
        />
      </Field>
      {error !== null && (
        <MessageBar intent="error">
          <MessageBarBody>
            The associated dataset name could not be loaded. {error}
          </MessageBarBody>
        </MessageBar>
      )}
    </>
  );
}

export function PrivateWorkspaceDatasetDetails(
  props: PrivateWorkspaceDatasetDetailsProps,
) {
  return (
    <DataHubClientProvider>
      <PrivateWorkspaceDatasetFields {...props} />
    </DataHubClientProvider>
  );
}
